import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "d-flex justify-content-end",
    "data-kt-customer-table-toolbar": "base"
  })
], -1)
const _hoisted_5 = { class: "card-body pt-0" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'settings'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", null, _toDisplayString(_ctx.translate('disclaimer')), 1)
          ]),
          _hoisted_4
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 10,
            total: _ctx.totalItems,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-screen": _withCtx(({ row: disclaimer }) => [
              _createTextVNode(_toDisplayString(disclaimer.screen), 1)
            ]),
            "cell-descEn": _withCtx(({ row: disclaimer }) => [
              _createTextVNode(_toDisplayString(disclaimer.descEn), 1)
            ]),
            "cell-descAr": _withCtx(({ row: disclaimer }) => [
              _createTextVNode(_toDisplayString(disclaimer.descAr), 1)
            ]),
            "cell-actions": _withCtx(({ row: disclaimer }) => [
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                onClick: _withModifiers(($event: any) => (_ctx.editDisclaimer(disclaimer.id)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                ])
              ], 8, _hoisted_6)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}